import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import '@shared/i18n/config'
import App from './App'
import { initializeBugPin } from '@shared/utils/bugpin'

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

initializeBugPin()

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
)
